// generalSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cpdActivitiesService } from "../../services/cpdActivitiesService";

// initial state
const initialState = {
  loading: false,
  page: 1,
  search: "",
  countries: [],
  cities: [],
  states: [],
  totalPages: 2,
  country_id: "",
  state_id: "",
  cpd_title: "",
  // saved_cpd_details: null,
  data: {
    current_page: 1,
    page_limit: 10,
    total_pages: 1,
  },
  startDate: null,
  endDate: null,
  isCPDStatusPending: 0,
  customSuccessPopup: false,
};

export const fetchUserCPDActivities = createAsyncThunk(
  "general/fetchUserCPDActivities",
  async (
    { page,
      limit,
      start_date,
      end_date,
      type_of_cpd,
      status, search },
    thunkAPI
  ) => {
    try {
      const response = await cpdActivitiesService.getUserCpdActivities({
        page,
        limit,
        start_date,
        end_date,
        type_of_cpd,
        status,
        search,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
  }
);

// General slice
const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    handleLoading: (state, action) => {
      state.loading = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    handleDataByType: (state, action) => {
      const newOptions = action?.payload[action?.payload?.dataType]?.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // Get the current list of countries from state
      const currentOptions = state[action?.payload?.dataType] || [];

      // Filter out duplicates by checking if the `value` already exists
      const filteredOptions = newOptions.filter(
        (newOption) => !currentOptions.some((existingOption) => existingOption.value === newOption.value)
      );

      // Update the state with non-duplicate options
      state[action?.payload?.dataType] = [...currentOptions, ...filteredOptions];
      state.page = state.page + 1;
      state.totalPages = action.payload.totalPages;
    },

    handleEmptyDataByType: (state, action) => {
      state[action?.payload?.dataType] = [];
      state.page = 1;
      state.totalPages = 2;
    },
    handleSearch: (state, action) => {
      state.search = action.payload;
    },
    handleCountryId: (state, action) => {
      state.country_id = action.payload;
    },
    handleStateId: (state, action) => {
      state.state_id = action.payload;
    },
    // saveCPDFormData: (state, action) => {
    //   state.saved_cpd_details = action.payload;
    // },
    clearCPDFormData: (state) => {
      state.saved_cpd_details = null;
    },
    handleCurrentPage: (state, action) => {
      state.data.current_page = action.payload;
    },
    handleIsCPDStatusPending: (state, action) => {
      state.isCPDStatusPending = action.payload;
    },
    setCustomSuccessPopup: (state, action) => {
      state.customSuccessPopup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserCPDActivities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserCPDActivities.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (action.payload.total_pages === 0) {
          state.data.total_pages = 1;
        } else {
          state.data.total_pages = action.payload.total_pages;
        }
      })
      .addCase(fetchUserCPDActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  }
});

// Export the authentication actions and reducer
export const {
  handleLoading,
  handleDataByType,
  handleSearch,
  handleEmptyDataByType,
  handleCountryId,
  handleStateId,
  setCPDTitleSearch,
  // saveCPDFormData,
  clearCPDFormData,
  handleCurrentPage,
  setStartDate,
  setEndDate,
  handleIsCPDStatusPending,
  setCustomSuccessPopup
} = generalSlice.actions;
export default generalSlice.reducer;
